<template>
  <v-dialog v-model="dialog" persistent max-width="500" content-class="version-dialog">
    <v-card>
      <v-card-text class="pt-6 text-center">
        <p class="version-modal-title mb-2">{{ $t("VersionModal.Title") }}</p>
        <p class="version-modal-message mb-0">{{ $t("VersionModal.Message") }}</p>
      </v-card-text>
      <v-card-actions class="justify-center pb-6">
        <v-btn class="version-modal-btn" depressed @click="reload">
          {{ $t("VersionModal.Reload") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VersionModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style>
.v-dialog.version-dialog.v-dialog--active.v-dialog--persistent {
  padding: 0 !important;
}
</style>

<style scoped>
.version-modal-title {
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #43207c;
}

.version-modal-message {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  color: #212121;
}

.version-modal-btn {
  background-color: #43207c !important;
  color: #ffffff !important;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-radius: 0;
  height: 42px;
  padding: 0 32px;
  text-transform: none;
  letter-spacing: 0;
}

.version-modal-btn:hover {
  background-color: #212121 !important;
}
</style>
